<template>
  <div class="operations-config">
    <el-alert
      title="配置仅控制新版客户端展示，不改变业务权限和审核流程。三端独立保存；旧版 App 需接入新接口后才会生效。"
      type="info"
      :closable="false"
    />
    <div class="toolbar">
      <el-radio-group
        :value="client"
        :disabled="loading || saving"
        @input="changeClient"
        ><el-radio-button
          v-for="(name, key) in clients"
          :key="key"
          :label="key"
          >{{ name }}</el-radio-button
        ></el-radio-group
      >
      <el-select
        :value="scene"
        :disabled="loading || saving"
        @input="changeScene"
        ><el-option
          v-for="(name, key) in scenes"
          :key="key"
          :value="key"
          :label="name"
      /></el-select>
      <el-button :disabled="loading || saving" @click="reload"
        >重新加载</el-button
      >
    </div>
    <div v-if="error">
      <el-alert title="加载失败，重试后再编辑" type="error" :closable="false" />
    </div>
    <div v-else-if="config" v-loading="loading">
      <template v-if="scene !== 'search'">
        <el-alert
          :title="sceneHint"
          type="warning"
          :closable="false"
        />
        <el-table :data="config.items">
          <el-table-column prop="key" label="固定编码" width="160" />
          <el-table-column label="显示名称"
            ><template slot-scope="s"
              ><el-input
                v-model="s.row.name"
                maxlength="12"
                :disabled="saving" /></template
          ></el-table-column>
          <el-table-column label="开启" width="110"
            ><template slot-scope="s"
              ><el-switch
                v-model="s.row.enabled"
                :disabled="saving || isFixed(s.row)" /></template
          ></el-table-column>
          <el-table-column label="排序" width="180"
            ><template slot-scope="s"
              ><span v-if="isFixed(s.row)">固定首位</span
              ><el-input-number
                v-else
                v-model="s.row.sort"
                :min="0"
                :max="999999"
                :precision="0"
                :disabled="saving" /></template
          ></el-table-column>
        </el-table>
        <el-form v-if="scene === 'release'" class="toolbar" label-width="160px">
          <el-form-item label="入场重点展示图标"
            ><el-select v-model="config.focus_key" :disabled="saving"
              ><el-option label="不展示动画" value="" /><el-option
                v-for="item in enabledItems"
                :key="item.key"
                :label="item.name"
                :value="item.key"
            /></el-select>
            <p class="tip">
              每次启动应用仅展示一次。关闭对应入口前，请先改选图标或关闭动画。
            </p></el-form-item
          >
        </el-form>
        <div class="preview">
          <span>展示顺序预览：</span
          ><el-tag v-for="item in previewItems" :key="item.key">{{
            item.name
          }}</el-tag
          ><span v-if="!previewItems.length">暂无开启的入口</span>
        </div>
      </template>
      <template v-else>
        <el-form label-width="130px" class="toolbar" :disabled="saving">
          <el-form-item label="搜索框提示"
            ><el-input v-model="config.placeholder" maxlength="40"
          /></el-form-item>
          <el-form-item label="默认搜索词"
            ><el-input
              v-model="config.defaultKeyword"
              maxlength="30"
              placeholder="留空则不自动代填搜索"
          /></el-form-item>
        </el-form>
        <h3>热门推荐词</h3>
        <p class="tip">优先使用有在售内容的品类、品牌或短词，如“名表”“名包”。小程序新版支持分类、城市和空格组合搜索；未接入新搜索接口的 App 仍按旧规则搜索。保存前请在对应客户端试搜，避免“酒店物资”等无结果推荐。</p>
        <el-table :data="config.keywords">
          <el-table-column label="热词"
            ><template slot-scope="s"
              ><el-input
                v-model="s.row.text"
                maxlength="30"
                :disabled="saving" /></template
          ></el-table-column>
          <el-table-column label="开启" width="90"
            ><template slot-scope="s"
              ><el-switch
                v-model="s.row.enabled"
                :disabled="saving" /></template
          ></el-table-column>
          <el-table-column label="排序" width="180"
            ><template slot-scope="s"
              ><el-input-number
                v-model="s.row.sort"
                :min="0"
                :max="999999"
                :precision="0"
                :disabled="saving" /></template
          ></el-table-column>
          <el-table-column label="操作" width="90"
            ><template slot-scope="s"
              ><el-button
                type="text"
                :disabled="saving"
                @click="config.keywords.splice(s.$index, 1)"
                >移除</el-button
              ></template
            ></el-table-column
          >
        </el-table>
        <el-button
          :disabled="saving || config.keywords.length >= 30"
          @click="
            config.keywords.push({
              text: '',
              sort: config.keywords.length * 10,
              enabled: true,
            })
          "
          >添加热词</el-button
        >
        <h3>默认推荐内容</h3>
        <p class="tip">
          从可公开资源、已上架商品、已审核合作和需求中选择，排序越小越靠前。下架后自动停止展示；移除推荐不会删除原信息。
        </p>
        <el-table :data="config.recommendations">
          <el-table-column label="内容"
            ><template slot-scope="s"
              >{{
                s.row.preview ? s.row.preview.title : "内容已失效，请停用或移除"
              }}
              <p class="tip">
                {{ types[s.row.type] }} #{{ s.row.id }}
              </p></template
            ></el-table-column
          >
          <el-table-column label="开启" width="90"
            ><template slot-scope="s"
              ><el-switch
                v-model="s.row.enabled"
                :disabled="saving" /></template
          ></el-table-column>
          <el-table-column label="排序" width="180"
            ><template slot-scope="s"
              ><el-input-number
                v-model="s.row.sort"
                :min="0"
                :max="999999"
                :precision="0"
                :disabled="saving" /></template
          ></el-table-column>
          <el-table-column label="操作" width="90"
            ><template slot-scope="s"
              ><el-button
                type="text"
                :disabled="saving"
                @click="config.recommendations.splice(s.$index, 1)"
                >移除</el-button
              ></template
            ></el-table-column
          >
        </el-table>
        <el-button
          v-auth="'/operations/config/candidates'"
          :disabled="saving || config.recommendations.length >= 20"
          @click="openPicker"
          >选择推荐内容</el-button
        >
      </template>
      <div class="save-bar">
        <el-button
          v-auth="'/operations/config/save'"
          type="primary"
          :loading="saving"
          :disabled="loading"
          @click="save"
          >保存到{{ clients[client] }} · {{ scenes[scene] }}</el-button
        ><span class="tip">配置版本 {{ revision }}</span>
      </div>
    </div>
    <el-dialog title="选择推荐内容" :visible.sync="picker" width="850px">
      <el-form inline @submit.native.prevent="loadCandidates(1)"
        ><el-select v-model="candidateType" @change="loadCandidates(1)"
          ><el-option
            v-for="(name, key) in types"
            :key="key"
            :value="key"
            :label="name" /></el-select
        ><el-input
          v-model="keyword"
          placeholder="按标题搜索"
          style="width: 260px"
        /><el-button @click="loadCandidates(1)">搜索</el-button></el-form
      >
      <el-table :data="candidates" v-loading="candidateLoading"
        ><el-table-column label="封面" width="85"
          ><template slot-scope="s"
            ><img
              v-if="s.row.image"
              :src="s.row.image"
              class="cover" /></template></el-table-column
        ><el-table-column prop="title" label="标题" /><el-table-column
          prop="price"
          label="价格 / 操作"
          width="130"
        /><el-table-column width="90"
          ><template slot-scope="s"
            ><el-button
              type="text"
              :disabled="selected(s.row) || config.recommendations.length >= 20"
              @click="select(s.row)"
              >{{ selected(s.row) ? "已选择" : "选择" }}</el-button
            ></template
          ></el-table-column
        ></el-table
      >
      <el-pagination
        :current-page="candidatePage"
        :page-size="15"
        :total="candidateTotal"
        layout="total,prev,pager,next"
        @current-change="loadCandidates"
      />
    </el-dialog>
  </div>
</template>
<script>
import { _get, _post } from "@/utils/request";
export default {
  data() {
    return {
      client: "weixin",
      scene: "home",
      clients: { weixin: "小程序", android: "Android", ios: "iOS" },
      scenes: {
        home_entries: "首页快捷入口",
        home: "首页资源页签",
        hall: "资源大厅页签",
        release: "发布中心",
        search: "搜索推荐",
      },
      types: {},
      config: null,
      revision: 0,
      loading: false,
      saving: false,
      error: false,
      baseline: "",
      picker: false,
      candidates: [],
      candidateType: "resource",
      keyword: "",
      candidatePage: 1,
      candidateTotal: 0,
      candidateLoading: false,
      candidateSerial: 0,
    };
  },
  computed: {
    sceneHint() {
      if (this.scene === "home_entries") {
        return "首页六个快捷入口独立配置，不影响首页资源页签或发布中心。排序数字越小越靠前，可全部关闭；改名不改变跳转目标。建议名称4至6个字。";
      }
      if (this.scene === "release") {
        return "编码固定；排序数字越小越靠前，可全部关闭。关闭入口不会删除内容，也不改变发布权限。";
      }
      return "编码固定；排序数字越小越靠前。推荐/全部始终开启且在首位，可修改显示名称。关闭标签不会删除内容。";
    },
    enabledItems() {
      return ((this.config && this.config.items) || []).filter(
        (item) => item.enabled
      );
    },
    previewItems() {
      return this.enabledItems
        .slice()
        .sort((a, b) =>
          this.isFixed(a)
            ? -1
            : this.isFixed(b)
            ? 1
            : a.sort - b.sort || a.key.localeCompare(b.key)
        );
    },
    dirty() {
      return this.config && JSON.stringify(this.config) !== this.baseline;
    },
  },
  created() {
    this.load();
  },
  beforeRouteLeave(to, from, next) {
    this.confirmDiscard()
      .then(() => next())
      .catch(() => next(false));
  },
  methods: {
    isFixed(item) {
      return (
        (this.scene === "home" && item.key === "recommended") ||
        (this.scene === "hall" && item.key === "all")
      );
    },
    confirmDiscard() {
      return this.dirty
        ? this.$confirm("当前修改尚未保存，确定放弃？", "未保存配置", {
            type: "warning",
          })
        : Promise.resolve();
    },
    changeClient(value) {
      this.confirmDiscard()
        .then(() => {
          this.client = value;
          this.load();
        })
        .catch(() => {});
    },
    changeScene(value) {
      this.confirmDiscard()
        .then(() => {
          this.scene = value;
          this.load();
        })
        .catch(() => {});
    },
    reload() {
      this.confirmDiscard()
        .then(() => this.load())
        .catch(() => {});
    },
    async load() {
      this.loading = true;
      this.error = false;
      this.config = null;
      try {
        const res = await _get("/shop/operations.config/index", {
          client: this.client,
          scene: this.scene,
        });
        this.config = res.data.config;
        this.revision = res.data.revision;
        this.types = res.data.types;
        if (res.data.scenes) this.scenes = res.data.scenes;
        this.baseline = JSON.stringify(this.config);
      } catch (e) {
        this.error = true;
      } finally {
        this.loading = false;
      }
    },
    async save() {
      if (this.saving || this.loading || !this.config) return;
      this.saving = true;
      try {
        const res = await _post("/shop/operations.config/save", {
          client: this.client,
          scene: this.scene,
          revision: this.revision,
          config: JSON.stringify(this.config),
        });
        this.revision = res.data.revision;
        this.baseline = JSON.stringify(this.config);
        this.$message.success("已保存，客户端下次进入页面读取生效");
      } catch (e) {
        /* 保留编辑内容供核对 */
      } finally {
        this.saving = false;
      }
    },
    openPicker() {
      this.picker = true;
      this.loadCandidates(1);
    },
    async loadCandidates(page) {
      const serial = ++this.candidateSerial;
      this.candidateLoading = true;
      this.candidates = [];
      try {
        const res = await _get("/shop/operations.config/candidates", {
          type: this.candidateType,
          keyword: this.keyword,
          page,
        });
        if (serial !== this.candidateSerial) return;
        this.candidates = res.data.list.data;
        this.candidateTotal = res.data.list.total;
        this.candidatePage = page;
      } catch (e) {
        if (serial === this.candidateSerial) this.candidateTotal = 0;
      } finally {
        if (serial === this.candidateSerial) this.candidateLoading = false;
      }
    },
    selected(item) {
      return this.config.recommendations.some(
        (ref) => ref.type === item.type && ref.id === item.target_id
      );
    },
    select(item) {
      if (!this.selected(item))
        this.config.recommendations.push({
          type: item.type,
          id: item.target_id,
          sort: this.config.recommendations.length * 10,
          enabled: true,
          preview: item,
        });
    },
  },
};
</script>
<style scoped>
.operations-config {
  padding: 20px;
  background: #fff;
}
.toolbar,
.preview,
.save-bar {
  margin: 20px 0;
}
.toolbar > * {
  margin-right: 12px;
}
.tip {
  color: #909399;
  font-size: 12px;
  line-height: 1.8;
}
.preview .el-tag {
  margin: 4px;
}
.save-bar {
  border-top: 1px solid #eee;
  padding-top: 20px;
}
.save-bar .tip {
  margin-left: 15px;
}
.cover {
  width: 60px;
  height: 45px;
  object-fit: cover;
}
h3 {
  margin-top: 30px;
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/views/operations/config/index.vue